import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Dialog, List } from 'libs/ui';
import { Title } from 'libs/form';
import { updatePermission } from 'services/role-service';
import { StyledButtonContainer, StyledInput, Content, Permissions } from './permissions-form.styled';

export const PermissionsForm = (props) => {
  const { t } = useTranslation();
  const { close, initialValues, id } = props;

  const [permissions, setPermissions] = useState(initialValues.permissions);
  const [flt, setFlt] = useState('');

  /**
   * change permission
   * @param {*} e
   * @param {*} name
   */
  const changePermission = (e, name) => {
    const val = e.target.checked;
    updatePermission(id, name, val).then(() => {
      const out = [...permissions];
      const idxOk = out.findIndex((el) => el.permission_id === name);
      out[idxOk].is_allowed = val;
      setPermissions(out);
    });
  };

  const filter = (e) => {
    setFlt(e.target.value);
  };

  const cancel = () => {
    close();
  };

  const filteredPermissions = permissions.filter((el) => el.permission_description.toLowerCase().includes(flt.toLowerCase()));

  const splitted = {
    'я': [],
  };
  filteredPermissions.forEach((el) => {
    if (el.permission_description.includes(': ')) {
      const name = el.permission_description.split(': ')
      if (!splitted[name[0]]) {
        splitted[name[0]] = [];
      }
      splitted[name[0]].push({...el, permission_description: name[1]})
    } else {
      splitted['я'].push(el);
    }
  });
  const keys = Object.keys(splitted);
  keys.sort();
  // console.log("splitted", splitted);

  return (
    <Dialog w={'580px'} top={10}>
      <Title>{t('form.Разрешения для роли ') + initialValues.name}</Title>
      <form>
        <Content>
          <Permissions>
            {keys.map((name, idx) => {
              const nameOk = name === 'я' ? '' : name;
              return <List key={idx} name={nameOk} items={splitted[name]} changePermission={changePermission} />
            })}
          </Permissions>
        </Content>
        <StyledButtonContainer space="20px">
          <StyledInput value={flt} onChange={filter} type="text" label={t('form.Поиск')} placeholder={t('form.Поиск')} name="flt" />
          <Button type="button" onClick={cancel}>
            {t('buttons.Закрыть')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Dialog>
  );
};
